module.exports = __webpack_public_path__ + "img/Ki.34533d80.svg";